import { render, staticRenderFns } from "./Seating_your_monitor.vue?vue&type=template&id=2b4af850"
import script from "./Seating_your_monitor.vue?vue&type=script&lang=js"
export * from "./Seating_your_monitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports